import * as React       from 'react';
import PropTypes        from 'prop-types';
import ReactTable       from 'react-table';
import { Pane, Tabs }   from '../../../tabs';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export default class FonctExpenseComponent extends React.Component {
	render() {
		return (
                <ReactTable
                className={this.props.singled ? 'singled' : ''}
                columns={this._getColumns(this.props.years)}
                collapseOnDataChange={false}
                data={this.props.data}
                defaultSorted={[{id: 'chapter.number'}, {id: 'account.number'}]}
                loading={this.props.loading}
                minRows={5}
                showPagination = {false}/>
		);
    }
    
    _getColumns = (
		/** @type {Number[]} */ years) => {

		return [
			{
				Header : 'Depenses de fonctionnement',
                columns: [
                    {
                        Header   : 'Libellé',
                        accessor : 'chapter',
                        minWidth : 230,
                        Cell     : cellinfo => {
                            if(cellinfo.original.chapter === null){
                                return "Non chapitrés"
                            }
                            else 
                            {
                                if(cellinfo.original.info) return cellinfo.original.info.label
                                if(!cellinfo.original.label && cellinfo.original.chapter) return cellinfo.original.chapter.label
                                if(cellinfo.original.id === "expense" || cellinfo.original.id === "orderoperation") return <strong> { cellinfo.original.label } </strong>
                                return cellinfo.original.label
                            }
                        },
                        sortMethod : (a, b) => {
                            if(a === null) return -1
                        },
                        Footer: (
                            <span>
                              <strong>Dépense total de fonctionnement :</strong>{" "}
                            </span>
                          )
                    }
                ]
			},
			{
				Header : 'Année',
                columns: this._getYearsColumns(years),
			}
		];
    }
    
    _getYearsColumns = (
		/** @type {Number[]} */ years
	) => {
		return years.map(y => ({
			Header    : y,
            accessor  : y.toString(),
            className : "text-right",
            Cell: c => 
            { 
                const value = this._getCurrencyNumber(c.value ? c.value : 0)
                if(c.original.id === "expense" || c.original.id === "orderoperation") return <strong> {value} </strong>
                return value
            },
			Footer: (
                      <span>
						{
                            this._getCurrencyNumber(_.sumBy(this.props.data, row => {
                                if(row.id && "orderoperation" === row.id || row.id && "expense" === row.id) return row[y.toString()]
                            }))
						}
					  </span>
			  )
		}));
    }

    _getCurrencyNumber = (value) => <FormattedNumber currency="EUR" style="currency" value={value} />
}

FonctExpenseComponent.propTypes = {
	loading  : PropTypes.bool.isRequired
}


// WEBPACK FOOTER //
// ./src/component/summary/operation/expense/expense-component.js